import React from 'react';
import IntegrationTable from '../../../../components/Tealium/TealiumApiKeys/IntegrationTable';
import { useContentfulContext } from '../../../../contexts/ContentfulContext';

const TealiumApiKey = () => {
  const { content } = useContentfulContext();

  return (
    <main id="main" className="stride-page-shell flex flex-col space-y-6">
      <div>
        <span className="stride-eyebrow">Setup / Integrations</span>
        <h1 className="text-2xl font-bold tracking-tight text-stride-heading">
          {content.TealiumApiKey_CONTENT.title}
        </h1>
        <p className="text-sm text-stride-muted mt-1">
          {content.TealiumApiKey_CONTENT.description}
        </p>
      </div>
      <div className="w-full">
        <IntegrationTable />
      </div>
    </main>
  );
};

export default TealiumApiKey;
